import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  Divider,
  TextField,
  Button,
  Tooltip,
  IconButton,
  Avatar,
} from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import axios from "axios";
import UseFetch from "../../customComponents/UseFetch";
import { createMRTColumnHelper } from "material-react-table";
import CustomTable from "../../components/customTable/CustomTable";
// import { Delete } from "@mui/icons-material";
import { toast } from "react-toastify";
import { handleDelete } from "../../utils/handleDelete";
import EditIcon from "@mui/icons-material/Edit";
import { ContentCopy, Delete as DeleteIcon } from "@mui/icons-material";
import EmployeeRole from "./EmployeeRole";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";
import { sidebarLinks } from "../../utils/links";

export const Roles = () => {
  const token = localStorage.getItem("token");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const [activeTab, setActiveTab] = useState("Role");
  const [showUpdateButton, setshowUpdateButton] = useState(false);

  const roleResponse = useSelector((state) => state?.login?.login?.role);
  const isParentSection = (entity) => Object.keys(sectionMap).includes(entity);

  const TableName = [
    "Dashboard", //section
    "BajajDashboard", //section

    "Role", //section
    "AdminEmployee",

    "BUY", //section
    "BuyInvoice",
    "BuyRequest",
    "BuyResponse",
    "MMTCBuyRequest",
    "MMTCBuyResponse",

    "Content", //section
    "AppBanner",
    "Blog",
    "CollateralUpload",
    "Faq",
    "HomeBanner",
    "MediaCoverage",
    "Notification",
    "Policy",
    "TemplateCreation",
    "WebBanner",

    "Jewellery", //section
    "JewelleryCatalogue",
    "Order",
    "SpotGoldQueries",

    "Operations", //section
    "kycmismatch",
    "tradefailed",
    "sendReport",
    "mmtcSellQuote",
    "Transactions",
    "Dsr",
    "fintsoTransactions",
    "GiftCard",
    "GiftCardUser",
    "kycUpdate",
    "Queries",
    "SalesTarget",
    "Sip",

    "Partners", //section
    "ActivePartner",
    "BatukPartner",
    "PartnerTransaction",
    "DistributorReport",
    "Mandates",
    "mutualFund",
    "partnerCommisssionReport",
    "Employees",
    "PartnerInvoice",
    "LoginTables",
    "PartnerRegisterations",
    "PartnerQR",
    "PartnerAllTransactions",
    "PartnerSip",
    "PartnerClient",
    "PartnerSubPartner",
    "PartnerEmployee",
    "PartnerProposal",
    "PartnerReport",
    "Proposals",

    "Redeem", //section
    "Redeems",
    "MMTCRedeems",

    "Reports", //section
    "ComplianceReport",
    "FileImportHistory",
    "InactiveClient",
    "Lumpsum",
    "MissingSIP",
    "SipBooked",
    "SIPBussinessReport",
    "SIPMining",

    "SELL", //section
    "SellInvoices",
    "SellRequests",
    "MMTCSellRequest",
    "MMTCSellResponse",

    "Users", //section
    "Address",
    "Banks",
    "Nominees",
    "Pan",
    "User",
    // "PartnerNotification",
    // "Users",
    // "Aadhar",
    // "AddressAugmont",
    // "BankAugmont",
    // "Cities",
    // "Clients",
    // "Countries",
    // "Redeems",
    // "Referrals",
    // "SellAugmonts",
    // "Settings",
    // "States",
    // "AdminEmployee",
    // "HelpAndSupport",
    // "AllPayments",
    // "RefundPayment",
    // "RefundReq",
    // "ImportPartner",
    // "WhatsAppChat",
    // "DigitalGold",
    // "Lampsum",
    // "SipBooking",
    // "userAugmonts",
    // "MaintenanceSetting",
    // "mmtc_buy_response",
    // "Mmtc",
    // "PartnerMaintenanceSetting"
    // "RewardSystem",
    // "GST",
    // "InactivePartner",
    // "userList",
    // "credentials_sent",
    // "AugmontBuy",
    // "AugmontSell",
    // "AugmontRedeem",
    // "MMTCBuy",
    // "MMTCSell",
    // "MMTCRedeem",
    // Augmont Redeems
  ];
  //new code------------------------------------
  const sectionMap = {
    Dashboard: [],

    BajajDashboard: [],

    Role: ["AdminEmployee"],

    BUY: [
      "BuyInvoice",
      "BuyRequest",
      "BuyResponse",
      "MMTCBuyRequest",
      "MMTCBuyResponse",
    ],

    Content: [
      "AppBanner",
      "Blog",
      "CollateralUpload",
      "Faq",
      "HomeBanner",
      "MediaCoverage",
      "Notification",
      "Policy",
      "TemplateCreation",
      "WebBanner",
    ],

    Jewellery: ["JewelleryCatalogue", "Order", "SpotGoldQueries"],

    Operations: [
      "kycmismatch",
      "tradefailed",
      "sendReport",
      "mmtcSellQuote",
      "Transactions",
      "Dsr",
      "fintsoTransactions",
      "GiftCard",
      "GiftCardUser",
      "kycUpdate",
      "Queries",
      "SalesTarget",
      "Sip",
    ],

    Partners: [
      "ActivePartner",
      "BatukPartner",
      "PartnerTransaction",
      "DistributorReport",
      "Mandates",
      "mutualFund",
      "partnerCommisssionReport",
      "Employees",
      "PartnerInvoice",
      "LoginTables",
      "PartnerRegisterations",
      "PartnerQR",
      "PartnerAllTransactions",
      "PartnerSip",
      "PartnerClient",
      "PartnerSubPartner",
      "PartnerEmployee",
      "PartnerProposal",
      "PartnerReport",
      "Proposals",
    ],

    Redeem: ["Redeems", "MMTCRedeems"],

    Reports: [
      "ComplianceReport",
      "FileImportHistory",
      "InactiveClient",
      "Lumpsum",
      "MissingSIP",
      "SipBooked",
      "SIPBussinessReport",
      "SIPMining",
    ],

    SELL: [
      "SellInvoices",
      "SellRequests",
      "MMTCSellRequest",
      "MMTCSellResponse",
    ],

    Users: ["Address", "Banks", "Nominees", "Pan", "User"],
  };

  const permissionLabels = {
    Dashboard: "Dashboard",
    BajajDashboard: "Bajaj Dashboard",

    Role: "Role Management",
    AdminEmployee: "Admin Employee",

    BUY: "Buy Section",
    BuyInvoice: "Augmont Buy Invoice",
    BuyRequest: "Augmont Buy Request",
    BuyResponse: "Augmont Buy Response",
    MMTCBuyRequest: "MMTC Buy Request",
    MMTCBuyResponse: "MMTC Buy Response",

    Content: "Content Management",
    AppBanner: "App Banner",
    Blog: "Blog",
    CollateralUpload: "Collateral Upload",
    Faq: "FAQ",
    HomeBanner: "Home Banner",
    MediaCoverage: "Media Coverage",
    Notification: "Notification",
    Policy: "Policy",
    TemplateCreation: "Template Creation",
    WebBanner: "Web Banner",

    Jewellery: "Jewellery Section",
    JewelleryCatalogue: "Jewellery Catalogue",
    Order: "Jewellery Order",
    SpotGoldQueries: "Jewellery Quote",

    Operations: "Operations Section",
    kycmismatch: "KYC Mismatch",
    tradefailed: "Trade Failed",
    sendReport: "Send Report",
    mmtcSellQuote: "MMTC Sell Quote",
    Transactions: "All Transactions",
    Dsr: "DSR",
    fintsoTransactions: "Fintso Transactions",
    GiftCard: "Gift Card Partner",
    GiftCardUser: "Gift Card User",
    kycUpdate: "KYC Update",
    Queries: "Queries",
    SalesTarget: "Sales Target",
    Sip: "SIP",

    Partners: "Partners Section",
    ActivePartner: "Active Partner",
    BatukPartner: "Batuk Partner",
    PartnerTransaction: "B2C Report",
    DistributorReport: "Distributor Report",
    Mandates: "Mandate",
    mutualFund: "MFD",
    partnerCommisssionReport: "Partner Commission Report",
    Employees: "Partner Employees",
    PartnerInvoice: "Partner Invoice",
    LoginTables: "Partner Login Tables",
    PartnerRegisterations: "Partner Registrations",
    PartnerQR: "Partner QR ",
    PartnerAllTransactions: "Partner All-Transactions",
    PartnerSip: "Partner Sip ",
    PartnerClient: "Partner Client ",
    PartnerSubPartner: "Partner Sub-Partner",
    PartnerEmployee: "Partner Employee ",
    PartnerProposal: "Partner Proposal ",
    PartnerReport: "Partner Report",
    Proposals: "Proposals",

    Redeem: "Redeem Section",
    Redeems: "Augmont Redeems",
    MMTCRedeems: "MMTC Redeems",

    Reports: "Partner Reports",
    ComplianceReport: "Compliance Report",
    FileImportHistory: "File Import History",
    InactiveClient: "Inactive Client",
    Lumpsum: "Lumpsum",
    MissingSIP: "Missing SIP",
    SipBooked: "SIP Booked",
    SIPBussinessReport: "SIP Business Report",
    SIPMining: "SIP Mining",

    SELL: "Sell Section",
    SellInvoices: "Augmont Sell Response",
    SellRequests: "Augmont Sell Requests",
    MMTCSellRequest: "MMTC Sell Request",
    MMTCSellResponse: "MMTC Sell Response",

    Users: "User Management",
    Address: "Address",
    Banks: "Banks",
    Nominees: "Nominees",
    Pan: "PAN",
    User: "Users",
  };
  const sectionIcons = sidebarLinks.reduce((acc, item) => {
    acc[item.ApiKeyForSideBar] = item.img;
    return acc;
  }, {});
  // console.log("sectionIcons----------------------", sectionIcons);

  const getChildren = (section) => sectionMap[section] || [];

  const getParentState = (section, perm) => {
    const children = getChildren(section);

    if (!children.length)
      return { checked: formData[section]?.[perm] === 1, indeterminate: false };

    const values = children.map((child) => formData[child]?.[perm] || 0);

    const allChecked = values.every((v) => v === 1);
    const noneChecked = values.every((v) => v === 0);

    return {
      checked: allChecked,
      indeterminate: !allChecked && !noneChecked,
    };
  };
  const getSelectAllState = (entity) => {
    const children = getChildren(entity);

    // if no children, use entity itself
    if (!children.length) {
      const perms = formData[entity] || {};
      const values = [
        perms.read ?? 0,
        perms.write ?? 0,
        perms.update ?? 0,
        perms.delete ?? 0,
        perms.export ?? 0,
      ];

      const allChecked = values.every((v) => v === 1);
      const noneChecked = values.every((v) => v === 0);

      return {
        checked: allChecked,
        indeterminate: !allChecked && !noneChecked,
      };
    }

    // only children permissions
    let values = [];

    children.forEach((child) => {
      const childPerms = formData[child] || {};
      values.push(
        childPerms.read ?? 0,
        childPerms.write ?? 0,
        childPerms.update ?? 0,
        childPerms.delete ?? 0,
        childPerms.export ?? 0,
      );
    });

    const allChecked = values.every((v) => v === 1);
    const noneChecked = values.every((v) => v === 0);

    return {
      checked: allChecked,
      indeterminate: !allChecked && !noneChecked,
    };
  };
  const handleParentChange = (section, perm) => (event) => {
    const checked = event.target.checked ? 1 : 0;
    const children = getChildren(section);

    setFormData((prev) => {
      const updated = { ...prev };

      updated[section][perm] = checked;

      children.forEach((child) => {
        if (updated[child]) {
          updated[child][perm] = checked;
        }
      });

      return updated;
    });
  };
  //--------------------new code-----------------------

  // Initialize formData with keys matching TableName
  const initialFormData = {
    name: "",
  };

  TableName.forEach((entity) => {
    initialFormData[entity] = {
      read: 0,
      write: 0,
      delete: 0,
      update: 0,
      export: 0,
    };
  });
  const handleSelectAll = (entity) => (event) => {
    const checked = event.target.checked ? 1 : 0;
    const children = getChildren(entity);

    setFormData((prev) => {
      const updated = { ...prev };

      updated[entity] = {
        read: checked,
        write: checked,
        update: checked,
        delete: checked,
        export: checked,
      };

      // propagate to children if entity is section
      children.forEach((child) => {
        updated[child] = {
          read: checked,
          write: checked,
          update: checked,
          delete: checked,
          export: checked,
        };
      });

      return updated;
    });
  };
  //----------------------------------------

  const isAllSelected = (entity) => {
    const permissions = formData[entity];
    if (!permissions) return false;

    return (
      permissions.read === 1 &&
      permissions.write === 1 &&
      permissions.update === 1 &&
      permissions.delete === 1 &&
      permissions.export === 1
    );
  };

  //---------------------------------

  const [formData, setFormData] = useState(initialFormData);

  // Function to handle checkbox state changes
  // const handleCheckboxChange = (entity, perm) => (event) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [entity]: {
  //       ...prev[entity],
  //       [perm]: event.target.checked ? 1 : 0,
  //     },
  //   }));
  // };
  //new code------------------------------------------
  const handleCheckboxChange = (entity, perm) => (event) => {
    const checked = event.target.checked ? 1 : 0;

    setFormData((prev) => {
      const updated = { ...prev };

      updated[entity][perm] = checked;

      const parent = Object.keys(sectionMap).find((section) =>
        sectionMap[section].includes(entity),
      );

      if (parent) {
        const children = sectionMap[parent];

        const values = children.map((child) => updated[child][perm]);

        const anyChecked = values.some((v) => v === 1);

        const allChecked = values.every((v) => v === 1);
        const noneChecked = values.every((v) => v === 0);

        // updated[parent][perm] = allChecked ? 1 : noneChecked ? 0 : 0;
        if (allChecked) {
          updated[parent][perm] = 1;
        } else if (noneChecked) {
          updated[parent][perm] = 0;
        } else {
          updated[parent][perm] = 1; // 🔥 partial me 0 mat hone do
        }
        // updated[parent][perm] = anyChecked ? 1 : 0;
      }

      return updated;
    });
  };
  //-------------------new code--------------

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let url = `/role_Create`;
      // let url = baseUrl + "/role_Create";
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.post(
        url,
        formData,
        //    {
        //   headers,
        // }
      );
      // const response = await axios.post(url, formData, {
      //   headers,
      // });
      if (response) {
        // toast.success(response?.data?.message);
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Role created successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        setRefresh(!refresh);
        setFormData(initialFormData);
      }
    } catch (error) {
      console.error("error :", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong",
      });
    }
  };

  /////////////////////////// table data ////////////////////////////////////////////
  const [refresh, setRefresh] = useState(false); // State to control refetch

  // UseFetch hook will re-run whenever `refresh` state changes
  const [tableData, loading] = UseFetch(`/role_list`, [refresh]);
  // const [tableData, loading] = UseFetch(`${baseUrl}/role_list`, [refresh]);
  // console.log("tableData: ", tableData);

  const PermissionAvatars = ({ permissions }) => {
    const avatarStyles = {
      height: "25px",
      width: "25px",
      fontSize: "12px",
    };

    // Mapping permission names to their display initials
    const permissionLabels = {
      read: "R",
      write: "W",
      update: "U",
      delete: "D",
      export: "E",
    };

    return (
      <Box sx={{ display: "flex", gap: "3px" }}>
        {Object.keys(permissions).map((permission) => (
          <Avatar
            key={permission}
            sx={{
              ...avatarStyles,
              backgroundColor: permissions[permission] === 1 ? "green" : "red",
              color: "white",
            }}
          >
            {permissionLabels[permission]}
          </Avatar>
        ))}
      </Box>
    );
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
    }),

    // permission columns
    ...TableName.map((table) =>
      columnHelper.accessor(table, {
        header: table.replace(/([A-Z])/g, " $1").trim(), // Makes "PartnerNotification" -> "Partner Notification"
        size: 30,
        Cell: (cell) => {
          const permissions = cell.row.original[table] || {};
          return (
            <PermissionAvatars
              permissions={{
                read: permissions.read,
                write: permissions.write,
                update: permissions.update,
                delete: permissions.delete,
                export: permissions.export,
              }}
            />
          );
        },
      }),
    ),
  ];

  if (roleResponse?.Role?.update === 1 || roleResponse?.Role?.delete === 1) {
    columns.unshift(
      columnHelper.accessor("Actions", {
        header: "Actions",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;

          return (
            <Box>
              {roleResponse?.Role?.update === 1 && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      handleEdit(rowData, "/role_edit");
                      setRefresh(!refresh);
                      setshowUpdateButton(!showUpdateButton);
                    }}
                  >
                    <EditIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
              {roleResponse?.Role?.delete === 1 && (
                <Tooltip title="Delete Role">
                  <IconButton
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Are you sure?",
                        text: "You will not be able to recover this post!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#4d16a4",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                      });
                      if (result.isConfirmed) {
                        handleDelete(rowId, "/role_delete");
                        setRefresh(!refresh);
                        Swal.fire(
                          "Deleted!",
                          "Your post has been deleted.",
                          "success",
                        );
                      }
                    }}
                  >
                    <DeleteIcon color="red" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      }),
    );
  }
  // Function to handle when the edit button is clicked
  const handleEdit = (data) => {
    const updatedFormData = { ...initialFormData, name: data.name || "" };
    // Loop through TableName and populate formData with existing or default values
    TableName.forEach((entity) => {
      updatedFormData[entity] = {
        read: data[entity]?.read ?? 0,
        write: data[entity]?.write ?? 0,
        update: data[entity]?.update ?? 0,
        delete: data[entity]?.delete ?? 0,
        export: data[entity]?.export ?? 0,
      };
    });
    // Set the updated formData to state
    setFormData(updatedFormData);
    // Update button visibility and set the roleId
    setshowUpdateButton(!showUpdateButton);
    setroleId(data._id);

    // Scroll to the top of the page smoothly
    window.scrollTo({
      top: 0,
      behavior: "smooth", // for smooth scrolling
    });
  };

  const [roleId, setroleId] = useState("");
  // console.log("roleId: ", roleId);
  // for update
  const handleUpdate = async () => {
    try {
      const url = `/role_update/${roleId}`;
      // const url = `${baseUrl}/role_update/${roleId}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(url, formData);

      if (response.data.error === false) {
        Swal.fire({
          text: response?.data?.message || "Role updated successfully",
          icon: "success",
          timer: 4000,
          showConfirmButton: false,
        });
        setRefresh(!refresh);
        setFormData(initialFormData);
        setshowUpdateButton(!showUpdateButton);
      } else {
        // toast.error("Failed to update employee");
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.data?.message || "Error updating employee",
        });
      }
    } catch (error) {
      console.error("Error updating employee", error);
      // toast.error("Error updating employee");
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Error updating employee",
      });
    }
  };

  return (
    <>
      {/*  */}
      <Box>
        <Box display="flex" justifyContent="center" mb={2}>
          <Button
            variant={activeTab === "Role" ? "contained" : "outlined"}
            onClick={() => setActiveTab("Role")}
            sx={{ marginRight: 2 }}
          >
            Role
          </Button>

          {roleResponse?.AdminEmployee?.read === 1 && (
            <Button
              variant={activeTab === "Employee" ? "contained" : "outlined"}
              onClick={() => setActiveTab("Employee")}
            >
              Employee
            </Button>
          )}
        </Box>

        {/* Conditionally render content based on activeTab */}
        {activeTab === "Role" && (
          <>
            {roleResponse?.Role?.write === 1 && (
              <Card>
                <CardHeader
                  sx={{ backgroundColor: "#fafafa" }}
                  avatar={
                    <Box display="flex" alignItems="center">
                      <ManageAccountsIcon sx={{ fontSize: 35 }} />

                      <TextField
                        type="text"
                        autoComplete="off"
                        label="Name"
                        name="name"
                        id="name"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={{ marginLeft: 1 }} // Adjust margin as needed
                      />
                    </Box>
                  }
                />
                <CardContent>
                  <Box component="form" noValidate autoComplete="off">
                    <Grid container spacing={0}>
                      {TableName.map((entity) => (
                        <React.Fragment key={entity}>
                          <Box
                            // sx={{
                            //   display: "flex",
                            //   alignItems: "center",
                            //   width: "100%",
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap", // ✅ ADD
                              width: "100%",
                              backgroundColor: isParentSection(entity)
                                ? "#f5f5f5"
                                : "transparent",
                              py: 0.5,
                              position: "relative",
                              mb: isParentSection(entity) ? 0.3 : 0,

                              // ...(isParentSection(entity) && {
                              //   "&::before": {
                              //     content: '""',
                              //     position: "absolute",
                              //     left: 0,
                              //     top: 0,
                              //     bottom: 0,
                              //     width: "4px",
                              //     backgroundColor: "#4A2A7D",
                              //   },
                              // }),
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              // md={3}
                              lg={3}
                              // lg={6}
                              container
                              alignItems="center"
                            >
                              {isParentSection(entity) && (
                                <img
                                  src={sectionIcons[entity]}
                                  alt={entity}
                                  width="35px"
                                  // key={index}
                                  style={{
                                    marginRight: "0rem",
                                  }}
                                />
                              )}
                              {/* <Typography>{entity}</Typography> */}
                              <Typography
                                // sx={{
                                //   fontWeight: isParentSection(entity) ? 700 : 400,
                                //   fontSize: isParentSection(entity) ? "15px" : "14px",
                                //   pl: isParentSection(entity) ? 1 : 4,
                                //   ml: !isParentSection(entity) ? 1 : 0, // ✅ space from icon/edge
                                // }}

                                sx={{
                                  fontWeight: isParentSection(entity)
                                    ? 700
                                    : 400,
                                  fontSize: isParentSection(entity)
                                    ? "15px"
                                    : "14px",

                                  display: "flex",
                                  alignItems: "center",

                                  // ❌ remove pl
                                  // pl: isParentSection(entity) ? 1 : 4,

                                  // ✅ indentation
                                  ml: isParentSection(entity) ? 1 : 4,

                                  // ✅ border exactly before text
                                  borderLeft: !isParentSection(entity)
                                    ? "3px solid #e0e0e0"
                                    : "none",

                                  // ✅ small space between border & text
                                  pl: !isParentSection(entity) ? 1 : 0,
                                }}
                              >
                                {permissionLabels[entity] || entity}
                              </Typography>
                            </Grid>

                            {[
                              "read",
                              "write",
                              "update",
                              "delete",
                              "export",
                              "selectAll",
                            ].map((perm) => {
                              const children = getChildren(entity);
                              const parentState = getParentState(entity, perm);
                              const selectAllState = getSelectAllState(entity);

                              return (
                                <Box
                                  // display="flex"
                                  // flexDirection="row"
                                  // alignItems="center"
                                  // justifyContent="space-evenly"
                                  display="flex"
                                  flexWrap="wrap" // ✅ ADD
                                  gap={1} // ✅ ADD
                                  alignItems="center"
                                  justifyContent="flex-start" // ✅ CHANGE
                                  key={`${entity}-${perm}`}
                                  sx={{
                                    ml: perm === "selectAll" ? 3 : 0,
                                    borderLeft:
                                      perm === "selectAll"
                                        ? "1px solid #ddd"
                                        : "none",
                                    pl: perm === "selectAll" ? 2 : 0,
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          perm === "selectAll"
                                            ? selectAllState.checked
                                            : children.length
                                              ? parentState.checked
                                              : formData[entity][perm] === 1
                                        }
                                        indeterminate={
                                          perm === "selectAll"
                                            ? selectAllState.indeterminate
                                            : perm !== "selectAll" &&
                                              children.length &&
                                              parentState.indeterminate
                                        }
                                        onChange={
                                          perm === "selectAll"
                                            ? handleSelectAll(entity)
                                            : children.length
                                              ? handleParentChange(entity, perm)
                                              : handleCheckboxChange(
                                                  entity,
                                                  perm,
                                                )
                                        }
                                      />
                                    }
                                    label={
                                      <Typography>
                                        {perm === "selectAll"
                                          ? "Select All"
                                          : perm.charAt(0).toUpperCase() +
                                            perm.slice(1)}
                                      </Typography>
                                    }
                                  />
                                </Box>
                              );
                            })}
                          </Box>
                          <Grid item xs={12}>
                            <Divider sx={{ marginY: 0.1 }} />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                  </Box>
                </CardContent>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 2,
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ marginRight: 1 }}
                    onClick={() => {
                      if (roleId) {
                        setFormData(initialFormData);
                        setshowUpdateButton(!showUpdateButton);
                        setroleId("");
                      } else {
                        setFormData(initialFormData);
                      }
                    }}
                  >
                    Cancel
                  </Button>
                  {showUpdateButton ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      Create
                    </Button>
                  )}
                </Box>
              </Card>
            )}
            <Box>
              <CustomTable
                columns={columns}
                data={tableData}
                loading={loading}
                permissionKey="Role"
              />
            </Box>
          </>
        )}

        {activeTab === "Employee" && <EmployeeRole />}
      </Box>
    </>
  );
};
